export const saveAskAQuestionQuery = `
mutation saveAskquestion($obj : AskquestionInput!){
  saveAskquestion(obj:$obj){
    id
  }
}
`